
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DOWNLOAD_CLIENT_TYPE } from '../constant';
import { DownloadUrls, So360DownloadCallbackData } from '../config/types';
import Footer from '../components/Footer.vue';
import PcVideoSection from './PcVideoSection.vue';
import PcGameListSection from './PcGameListSection.vue';
import { collectDownload } from '@/config/collect';
import { downloadAndroidApp, downloadIosApp } from '../utils/appDownload';
import { downloadResolvedFile } from '../utils/resolveDownloadUrl';

@Component({
  components: { Footer, PcVideoSection, PcGameListSection },
})
export default class PcPage extends Vue {
  @Prop({ required: true }) public downloadUrls!: DownloadUrls;
  @Prop({ default: false }) public hideList!: boolean;
  @Prop({ default: false }) public showAppInfo!: boolean;
  @Prop({ default: false }) public isBaiduDeveloper!: boolean;
  @Prop({ default: true }) public showAddress!: boolean;
  @Prop({ default: '' }) public developerName!: string;
  @Prop({ default: () => require('@/assets/video/rj.mp4') }) public videoSrc!: string;
  @Prop({ default: false }) public showIosDownload!: boolean;
  @Prop({ default: false }) public customVideoButtons!: boolean;
  @Prop({ default: '' }) public baiduApiToken!: string;
  @Prop() public so360DownloadConfig?: So360DownloadCallbackData;
  @Prop() public byDownloadConfig!: So360DownloadCallbackData;
  @Prop({ default: false }) public collectEnabled!: boolean;

  public downloadClientType = DOWNLOAD_CLIENT_TYPE;

  /** 配置隐藏，或地址栏带 game_id 时隐藏游戏列表 */
  get shouldHideList() {
    const gameId = (this as any).$route.query.game_id;
    const hasGameId = Array.isArray(gameId) ? !!gameId[0] : !!gameId;
    return this.hideList || hasGameId;
  }

  get containerClass() {
    return {
      'no-list': this.shouldHideList,
      'video-only-buttons': this.customVideoButtons,
    };
  }

  public handleDownload(type: string) {
    if (type === DOWNLOAD_CLIENT_TYPE.IOS) {
      if (this.collectEnabled) {
        collectDownload('APP');
      }
      downloadIosApp({ iosDownloadUrl: '', iosAppKey: '' });
      return;
    }
    if (!this.downloadUrls[type][process.env.NODE_ENV]) {
      return;
    }
    if (type === DOWNLOAD_CLIENT_TYPE.ANDROID) {
      if (this.collectEnabled) {
        collectDownload('APP');
      }
      downloadAndroidApp(this.downloadUrls);
      return;
    }
    if (type === DOWNLOAD_CLIENT_TYPE.PC && this.collectEnabled) {
      collectDownload('PC');
    }
    const rawUrl = this.downloadUrls[type][process.env.NODE_ENV];
    downloadResolvedFile(rawUrl, type, {
      baiduApiToken: this.baiduApiToken,
      so360DownloadConfig: this.so360DownloadConfig,
      byDownloadConfig: this.byDownloadConfig,
      query: (this as any).$route.query,
    });
  }
}
